import axios from "axios";
import { ITopElement } from "backend/model/model";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";

const useTopElements = () => {
  const ctx = useAppContext();

  return useQuery<ITopElement[]>(
    "use-topelements",
    async () => {
      const response = await axios.get(
        `/workflow/topelements/SC.${ctx.modelId}`,
        {}
      );

      return response.data?.data?.map((topelement: any) => {
        topelement.JS_ATTR = topelement.translations || "";
        delete topelement.translations;
        return topelement;
      });
    },
    {
      enabled: true,
      staleTime: 30 * 60 * 1000, // cache result
    }
  );
};

export default useTopElements;
